<template>
  <section class="services">
    <div v-if="content">
      <div class="services__header center">
        <h1>{{ content.mainTitle }}</h1>
        <p v-html="content.intro"></p>
      </div>

      <div class="services__items grid-2-col">
        <div v-for="service in content.servicesList" :key="service.route" class="services__item">
          <div class="services__image-wrapper image">
            <img v-if="service.contentImage" :src="getImagePath(service.contentImage)" :alt="service.title" class="services__image" />
            <div class="services__overlay">
              <div class="services__overlay-content">
                <h3 class="services__name">{{ service.title }}</h3>
          
                <!-- <router-link :to="service.route" class="consultation-button">
                  {{ $t("button.details") }}
                </router-link> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <p>Загружается контент...</p>
    </div>
  </section>
</template>

<script>
import { useServicesStore } from "@/stores/servicesStore";
import { mapState } from "pinia";

export default {
  name: "ServicesTemplate",
  computed: {
    ...mapState(useServicesStore, ["content"]),
  },
  watch: {
    "$i18n.locale"(newLocale) {
      this.loadData(newLocale);
    }
  },
  methods: {
    loadData(locale) {
      const store = useServicesStore();
      store.loadContent(locale);
    },
    getImagePath(imagePath) {
      return imagePath.startsWith("/services_img/") ? imagePath : `/services_img/${imagePath}`;
    }
  },
  mounted() {
    this.loadData(this.$i18n.locale);
  },
};
</script>

